import React, { useCallback, useEffect, useMemo, useState } from "react";
import { ChartAreaLoader } from "../../../../components/Loading";
import Tooltip from "../../../../components/tooltip";
import SecondaryHeader from "../../../Rajasthan/Demand/SecondaryHeader";
import { getRealTimePrices } from "../../../../Rest_api/RestApi";
import {
  ChartDataParams,
  FormatChartData,
} from "../../../../components/recharts/functions";
import { useDispatch, useSelector } from "react-redux";
import {
  updateDateRangeOptions,
  updateDefaultDates,
} from "../../../../store/state/DefaultDatesSetter";
import { AddDatesWithFileName } from "../../../../helpers/helper";
import { ReMixChart } from "../../../../components/recharts/ReMixCharts";
import { BrushStart } from "../../../../models/chart_model";
import { renderHourTick } from "../../../../components/recharts/components";
import LegendSummaryTable, {
  ChartTable,
} from "../../../../components/table/SummaryTable";
import { useLegendFilter } from "../../../../hooks/useLegendFilter";
import { ExchangeDataTabs } from "../../../Rajasthan/Demand/Data";
import BlockRangeSelector from "../../../../components/BlockRangeSelector/BlockRangeSelector";
import { normalizeDisplayLabelWithoutUndefined } from "../../../../utility/displayText";

interface RealTimePriceData {
  date: string;
  block: number;
  rate_type: string;
  rate_value: number;
}

const Realtime = () => {
  const dispatch = useDispatch();
  const activeTab = useSelector((state: any) => state.switchTabs.activeTab);
  const [loading, setLoading] = useState(false);
  const DefaultDates = useSelector(
    (state: any) => state.defaultDatesSetter.defaultDates
  );

  const dataTab = useSelector((state: any) => state.viewMode.activeView);
  const [data, setData] = useState<RealTimePriceData[]>([]);
  const [chartKeys, setChartKeys] = useState<any[]>([]);
  const [chartData, setChartData] = useState<any[]>([]);
  const [TableData, setTableData] = useState<any[]>([]);
  const [dateOptions, setDateOptions] = useState<any[]>([]);
  const [uniqueBlock, setUniqueBlock] = useState<any[]>([]);
  const [selectedBlock, setSelectedBlock] = useState<any[]>([]);

  const createChartObject = (key: string, index: number) => {
    return {
      dataKey: `${key}_rate_value`,
      name: `${normalizeDisplayLabelWithoutUndefined(key)}`,
      unit: "Rs/KWh",
    };
  };

  const memoizedLegends = useMemo(() => {
    return chartKeys.map((key, index) => createChartObject(key, index) as any);
  }, [chartKeys]);

  const { visibleLegends, handleLegendSelect, selectedLegends } =
    useLegendFilter(memoizedLegends);

  const _handlefetchData = useCallback(async () => {
    setLoading(true);
    const newData = await getRealTimePrices();
    setData(newData);
    const uniqueDates = Array.from(
      new Set(newData.map((item: { date: any }) => item.date))
    );
    setDateOptions(uniqueDates.map((date) => ({ value: date, label: date })));
    setUniqueBlock(
      Array.from(new Set(newData.map((item: { block: any }) => item.block)))
    );
    setLoading(false);
  }, []);

  useEffect(() => {
    _handlefetchData();
  }, [_handlefetchData]);

  useEffect(() => {
    dispatch(
      updateDateRangeOptions({
        activeTab,
        dates: dateOptions,
      })
    );
    dispatch(
      updateDefaultDates({
        activeTab,
        dates: dateOptions[0],
      })
    );
  }, [activeTab, dateOptions, dispatch]);

  useEffect(() => {
    let filteredData = data;
    if (DefaultDates[activeTab].defaultRangeDate?.value) {
      const selectedDate = DefaultDates[activeTab].defaultRangeDate.value;
      filteredData = data.filter((item) => item.date === selectedDate);
    }

    if (selectedBlock.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedBlock.map((item) => item.value).includes(item.block)
      );
    }
    const par: ChartDataParams = {
      keys: ["date", "block"],
      tableKeys: ["date", "block", "month"],
      groupBy: ["rate_type"],
      volumeKey: ``,
      aggregationKeys: ["rate_value"],
      priceKey: "",
      data: filteredData,
    };
    const cData = FormatChartData(par);
    setChartData(cData.data);
    setChartKeys(cData.keys);
    setTableData(cData.tableData || []);
  }, [DefaultDates, activeTab, data, selectedBlock]);

  // The original createChartObject and getLegends are now replaced by memoizedLegends and createChartObject above
  // function getLegends() {
  //   return chartKeys.map((key, index) => createChartObject(key, index) as any);
  // }

  const tablePar = {
    legends: visibleLegends,
    data: chartData,
    tableData: TableData,
    itemsPerPage: 96,
    extraKeys: ["block", "date"],
    extraLabels: ["Block", "Date"],

    filename: AddDatesWithFileName({
      fileName: "Realtime",
      dates: DefaultDates[activeTab].defaultRangeDate,
    }),
    showTotal: false,
  };

  return (
    <>
      <div className="gas-page-container">

        <div className="flex flex-col gap-2 m-3 justify-between w-full">
          <SecondaryHeader ExchangeDataTabs={ExchangeDataTabs} />
          <div className="gas-chart-container">
            {loading ? <ChartAreaLoader title="Loading Realtime" subtitle="Fetching exchange real time price data…" /> : (<>
              <div
                style={{ borderBottom: "1px solid #DFEAF2" }}
                className="gas-heading gap-x-10 pb-5"
              >
                <h2 className="chartHeading w-60">Real Time</h2>
                <div className="flex gap-x-6  justify-end">
                  {/* <SearchBox
                  options={uniqueBlock.map((item) => {
                    return { value: item, label: item };
                  })}
                  isMany={true}
                  placeholder="Search Block"
                  selectedOptions={selectedBlock}
                  onChange={setSelectedBlock}
                /> */}
                  <BlockRangeSelector
                    blocks={Array.from({ length: 96 }, (_, i) => i + 1)}
                    placeholder="Select Slot"
                    selectedOptions={selectedBlock.map((item) => item.value)}
                    setSelectedOptions={setSelectedBlock}
                  />
                  {/* <button
                  onClick={() => {
                    dataTab.label === "Chart" &&
                      downloadChartTableCSV(tablePar);

                    dataTab.label === "Summary" && downloadSummaryCSV(tablePar);

                    dataTab.label === "Table" &&
                      downloadChartTableCSV(tablePar);
                  }}
                  className="downloadButton"
                >
                  Download Data
                </button> */}
                </div>
              </div>

              {dataTab.label === "Chart" && (
                <ReMixChart
                  data={chartData}
                  showBrush={chartData.length > 96 ? true : undefined}
                  brushStart={BrushStart.Start}
                  isTimeSlot={true}
                  onlyTitle={true}
                  barCategoryGap={10}
                  unit={"Rs/KWh"}
                  yAxisLabel="Rs/KWh"
                  legends={memoizedLegends}
                  onLegendSelect={handleLegendSelect}
                  defaultSelectedLegends={selectedLegends}
                  xDataKey={"block"}
                  xTick={(value: any, index: any) => {
                    return renderHourTick(value, 10);
                  }}
                  secondXDataKey={"date"}
                />
              )}
              {dataTab.label === "Summary" && (
                <LegendSummaryTable {...tablePar} />
              )}
              {dataTab.label === "Table" && <ChartTable {...tablePar} />}
            </>)}
          </div>
          <div className="gna-footer-container">
            <div className="grid grid-cols-3 justify-between gap-5 ">
              <Tooltip note={<div className="text-start">
                <p>1. HPX | Hindustan Power Exchange</p>
                <p>2. IEX | Indian Energy Exchange</p>
                <p>3. PXIL | Power Exchange of India Limited</p>
              </div>} text=" ">
                <p className="gna-footer-text">Source</p>
              </Tooltip>
              <p className="gna-footer-text col-span-1 text-center">
                Powered by <strong>GNA Energy</strong>
              </p>
              <strong className="gna-footer-text col-span-1 text-end">
                Beta Version
              </strong>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Realtime;